import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const rows = [{
  label: 'Ruta Hipertensión (6 Tomos Clínicos)',
  value: '$97 USD'
}, {
  label: '5 Bonos Exclusivos',
  value: '$150 USD'
}];
const perks = ['Descarga inmediata', 'Pago único', 'Acceso de por vida', 'Garantía de 7 días'];
export function Offer() {
  return <section className="w-full bg-cream px-4 py-14" aria-labelledby="oferta" data-id="element-201" data-mp="3a3m9vlzpzqrc">
      <div className="mx-auto w-full max-w-2xl" data-id="element-202" data-mp="3f2p9gqwxl4rx">
        <p className="text-center text-xs font-extrabold uppercase tracking-[0.25em] text-brandred" data-id="element-203" data-mp="3juqhu1qzabco">
          Oferta especial de lanzamiento
        </p>
        <h2 id="oferta" className="mt-3 text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-204" data-mp="3nyy4zuhsfj8s">
          Si compraras cada recurso por separado, esto sería lo que pagarías
        </h2>

        <div className="mt-7 rounded-3xl border border-navy/10 bg-white p-5 shadow-xl shadow-navy/5" data-id="element-205" data-mp="1klqe0f7c8xt9">
          <ul className="divide-y divide-navy/10" data-id="element-206" data-mp="1fm3yfz41f5ha">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-4 py-3" data-id="element-207" data-mp="1bka0vzp52hlc">
                <span className="text-[15px] font-medium text-navy/75" data-id="element-208" data-mp="16n9x5vfrhqxe">
                  {row.label}
                </span>
                <span className="shrink-0 text-[15px] font-bold text-navy" data-id="element-209" data-mp="23dsm325wz5rw">
                  {row.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-4 rounded-2xl bg-navy-tint px-4 py-3 text-center" data-id="element-210" data-mp="1ui3658n8j3lw">
            <p className="text-sm font-semibold text-navy/70" data-id="element-211" data-mp="1pji1mx0y9xrn">
              Valor total del sistema
            </p>
            <p className="font-display text-3xl font-extrabold text-navy line-through decoration-brandred decoration-2" data-id="element-212" data-mp="2n1i5akzsbxpi">
              $247 USD
            </p>
          </div>

          <div className="mt-5 text-center" data-id="element-213" data-mp="316ij2k5nwmgi">
            <p className="text-sm font-semibold uppercase tracking-widest text-brandred" data-id="element-214" data-mp="317tkidbmxi4g">
              Hoy pagas solo
            </p>
            <p className="font-display text-6xl font-extrabold leading-none text-brandred" data-id="element-215" data-mp="2sdp0odux56yf">
              $14
              <span className="ml-1 align-top text-xl font-bold text-navy" data-id="element-216" data-mp="2wdz7ttug63ev">
                USD
              </span>
            </p>
            <p className="mt-3 text-[15px] font-semibold text-navy" data-id="element-217" data-mp="2idobibadbwmb">
              Un único pago. Sin mensualidades, sin renovaciones, sin costos
              ocultos.
            </p>
            <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-navy-tint px-3.5 py-2 text-[12px] font-semibold text-navy/75" data-id="element-218" data-mp="29fmdm4lxlk39">
              <GlobeIcon className="h-4 w-4 text-brandred" aria-hidden="true" data-id="element-219" data-mp="7myadv9aewnh" />
              El cambio de moneda es automático según tu país
            </p>
          </div>

          <ul className="mt-5 grid grid-cols-2 gap-2" data-id="element-220" data-mp="bnqiumac4xip">
            {perks.map(perk => <li key={perk} className="flex items-center gap-2 rounded-xl bg-cream px-3 py-2.5 text-[13px] font-semibold text-navy" data-id="element-221" data-mp="1w73uuscpr02y">
                <CheckIcon className="h-4 w-4 shrink-0 text-brandred" aria-hidden="true" data-id="element-222" data-mp="25x5hrgtbycga" />
                {perk}
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-223" data-mp="2ft04oo4l6tov">
            <CTAButton label="Quiero Ruta Hipertensión por $14 USD" size="lg" data-id="element-224" data-mp="2avgr7qfpqkxz" />
          </div>

          <div className="mt-5" data-id="element-225" data-mp="2axt963lh0vb1">
            <Countdown data-id="element-226" data-mp="2ovhqx2k8rmbv" />
          </div>

          <div className="mt-5" data-id="element-227" data-mp="2ougeatnkurs1">
            <ScarcityBar data-id="element-228" data-mp="2jwekpesiza2b" />
          </div>
        </div>

        <div className="mt-8 space-y-2 rounded-3xl border border-navy/10 bg-white p-5 text-center text-[15px] leading-relaxed text-navy/75" data-id="element-229" data-mp="2jwobv5pb3n9l">
          <p className="font-display text-lg font-bold text-navy" data-id="element-230" data-mp="pidn0x8pot3t">
            Piensa en esto por un momento…
          </p>
          <p data-id="element-231" data-mp="rxk3l3nhxxmo">¿Cuánto vale evitar una sola decisión clínica equivocada?</p>
          <p data-id="element-232" data-mp="vy41wajt37ae">¿Cuánto vale recuperar las horas que hoy pierdes revisando guías?</p>
          <p data-id="element-233" data-mp="w08fjk7ibknv">
            ¿Cuánto vale entrar a consulta sabiendo exactamente cuál es el
            siguiente paso?
          </p>
          <p className="pt-2 font-semibold text-navy" data-id="element-234" data-mp="15x3bbvceb6yg">
            Cuesta menos que una consulta médica en muchos países, pero puede
            acompañarte en cientos de consultas durante años.
          </p>
        </div>
      </div>
    </section>;
}